module.exports = __webpack_public_path__ + "img/vertical_7_4_6005.91a82c87.png";